import { render, staticRenderFns } from "./apiproductreport-add-or-update.vue?vue&type=template&id=86386a3a&"
import script from "./apiproductreport-add-or-update.vue?vue&type=script&lang=js&"
export * from "./apiproductreport-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports